/* eslint-disable arrow-body-style */
import React from 'react';
import { TextField, FormControl, FormControlLabel, Checkbox, Stack, Typography } from '@mui/material';

const AdditionalServiceFeesSection = ({ formik, onFieldBlur }) => {
  return (
    <>
      <FormControl>
        <FormControlLabel
          control={
            <Checkbox
              name="additional_service_fees_enabled"
              checked={formik.values.additional_service_fees_enabled || false}
              onChange={(e) => {
                formik.setFieldValue('additional_service_fees_enabled', e.target.checked);
                if (!e.target.checked) {
                  formik.setFieldValue('credentialing_per_provider_enabled', false);
                  formik.setFieldValue('credentialing_per_provider_fee', '');
                  formik.setFieldValue('prior_authorization_enabled', false);
                  formik.setFieldValue('prior_authorization_flat_fee', '');
                  formik.setFieldValue('special_project_rate_enabled', false);
                  formik.setFieldValue('special_project_rate_per_hour', '');
                  formik.setFieldValue('other_fee_enabled', false);
                  formik.setFieldValue('other_service_fee_field_name', '');
                  formik.setFieldValue('other_service_fee_field_value', '');
                }
              }}
            />
          }
          label="Additional Service Fees"
        />
      </FormControl>

      {formik.values.additional_service_fees_enabled && (
        <div
          style={{
            backgroundColor: '#f9f9f9',
            padding: '16px',
            borderRadius: '8px',
            marginTop: '16px',
            border: '1px solid #e0e0e0',
          }}
        >
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            Additional Service Fees
          </Typography>
          <Stack spacing={2}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    name="credentialing_per_provider_enabled"
                    checked={formik.values.credentialing_per_provider_enabled}
                    onChange={(e) => {
                      formik.setFieldValue('credentialing_per_provider_enabled', e.target.checked);
                      if (!e.target.checked) {
                        formik.setFieldValue('credentialing_per_provider_fee', '');
                      }
                    }}
                  />
                }
                label="Credentialing per Provider"
              />
              {formik.values.credentialing_per_provider_enabled && (
                <TextField
                  id="credentialing_per_provider_fee"
                  name="credentialing_per_provider_fee"
                  label="Fee Amount"
                  type="number"
                  value={formik.values.credentialing_per_provider_fee}
                  onChange={(e) => {
                    const nextValue = e.target.value;
                    if (nextValue === '') {
                      formik.setFieldValue('credentialing_per_provider_fee', '');
                      return;
                    }
                    const parsed = parseFloat(nextValue);
                    formik.setFieldValue(
                      'credentialing_per_provider_fee',
                      Number.isFinite(parsed)
                        ? String(Math.max(0, parsed))
                        : formik.values.credentialing_per_provider_fee
                    );
                  }}
                  onBlur={() => onFieldBlur('credentialing_per_provider_fee')}
                  error={
                    formik.touched.credentialing_per_provider_fee &&
                    Boolean(formik.errors.credentialing_per_provider_fee)
                  }
                  helperText={
                    formik.touched.credentialing_per_provider_fee && formik.errors.credentialing_per_provider_fee
                  }
                  InputProps={{
                    startAdornment: <span style={{ marginRight: '8px' }}>$</span>,
                    inputProps: { min: 0 },
                  }}
                  placeholder="Enter fee amount"
                  size="small"
                  style={{ marginLeft: '32px', marginTop: '8px' }}
                />
              )}
            </FormControl>

            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    name="prior_authorization_enabled"
                    checked={formik.values.prior_authorization_enabled}
                    onChange={(e) => {
                      formik.setFieldValue('prior_authorization_enabled', e.target.checked);
                      if (!e.target.checked) {
                        formik.setFieldValue('prior_authorization_flat_fee', '');
                      }
                    }}
                  />
                }
                label="Prior authorization flat fee per authorization"
              />
              {formik.values.prior_authorization_enabled && (
                <TextField
                  id="prior_authorization_flat_fee"
                  name="prior_authorization_flat_fee"
                  label="Fee Amount"
                  type="number"
                  value={formik.values.prior_authorization_flat_fee}
                  onChange={(e) => {
                    const nextValue = e.target.value;
                    if (nextValue === '') {
                      formik.setFieldValue('prior_authorization_flat_fee', '');
                      return;
                    }
                    const parsed = parseFloat(nextValue);
                    formik.setFieldValue(
                      'prior_authorization_flat_fee',
                      Number.isFinite(parsed)
                        ? String(Math.max(0, parsed))
                        : formik.values.prior_authorization_flat_fee
                    );
                  }}
                  onBlur={() => onFieldBlur('prior_authorization_flat_fee')}
                  error={
                    formik.touched.prior_authorization_flat_fee && Boolean(formik.errors.prior_authorization_flat_fee)
                  }
                  helperText={formik.touched.prior_authorization_flat_fee && formik.errors.prior_authorization_flat_fee}
                  InputProps={{
                    startAdornment: <span style={{ marginRight: '8px' }}>$</span>,
                    inputProps: { min: 0 },
                  }}
                  placeholder="Enter fee per authorization"
                  size="small"
                  style={{ marginLeft: '32px', marginTop: '8px' }}
                />
              )}
            </FormControl>

            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    name="special_project_rate_enabled"
                    checked={formik.values.special_project_rate_enabled}
                    onChange={(e) => {
                      formik.setFieldValue('special_project_rate_enabled', e.target.checked);
                      if (!e.target.checked) {
                        formik.setFieldValue('special_project_rate_per_hour', '');
                      }
                    }}
                  />
                }
                label="Special project rate per hour"
              />
              {formik.values.special_project_rate_enabled && (
                <TextField
                  id="special_project_rate_per_hour"
                  name="special_project_rate_per_hour"
                  label="Rate per Hour"
                  type="number"
                  value={formik.values.special_project_rate_per_hour}
                  onChange={(e) => {
                    const nextValue = e.target.value;
                    if (nextValue === '') {
                      formik.setFieldValue('special_project_rate_per_hour', '');
                      return;
                    }
                    const parsed = parseFloat(nextValue);
                    formik.setFieldValue(
                      'special_project_rate_per_hour',
                      Number.isFinite(parsed)
                        ? String(Math.max(0, parsed))
                        : formik.values.special_project_rate_per_hour
                    );
                  }}
                  onBlur={() => onFieldBlur('special_project_rate_per_hour')}
                  error={
                    formik.touched.special_project_rate_per_hour && Boolean(formik.errors.special_project_rate_per_hour)
                  }
                  helperText={
                    formik.touched.special_project_rate_per_hour && formik.errors.special_project_rate_per_hour
                  }
                  InputProps={{
                    startAdornment: <span style={{ marginRight: '8px' }}>$</span>,
                    inputProps: { min: 0 },
                  }}
                  placeholder="Enter hourly rate"
                  size="small"
                  style={{ marginLeft: '32px', marginTop: '8px' }}
                />
              )}
            </FormControl>

            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    name="other_fee_enabled"
                    checked={formik.values.other_fee_enabled}
                    onChange={(e) => {
                      formik.setFieldValue('other_fee_enabled', e.target.checked);
                      if (!e.target.checked) {
                        formik.setFieldValue('other_service_fee_field_name', '');
                        formik.setFieldValue('other_service_fee_field_value', '');
                      }
                    }}
                  />
                }
                label="Other"
              />
              {formik.values.other_fee_enabled && (
                <div style={{ marginLeft: '32px', marginTop: '8px' }}>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <TextField
                      id="other_service_fee_field_name"
                      name="other_service_fee_field_name"
                      label="Service Name"
                      value={formik.values.other_service_fee_field_name}
                      onChange={formik.handleChange}
                      onBlur={() => onFieldBlur('other_service_fee_field_name')}
                      error={
                        formik.touched.other_service_fee_field_name &&
                        Boolean(formik.errors.other_service_fee_field_name)
                      }
                      helperText={
                        formik.touched.other_service_fee_field_name && formik.errors.other_service_fee_field_name
                      }
                      placeholder="Enter service name"
                      size="small"
                      style={{ flex: 1 }}
                    />
                    <TextField
                      id="other_service_fee_field_value"
                      name="other_service_fee_field_value"
                      label="Fee Amount"
                      type="number"
                      value={formik.values.other_service_fee_field_value}
                      onChange={(e) => {
                        const nextValue = e.target.value;
                        if (nextValue === '') {
                          formik.setFieldValue('other_service_fee_field_value', '');
                          return;
                        }
                        const parsed = parseFloat(nextValue);
                        formik.setFieldValue(
                          'other_service_fee_field_value',
                          Number.isFinite(parsed)
                            ? String(Math.max(0, parsed))
                            : formik.values.other_service_fee_field_value
                        );
                      }}
                      onBlur={() => onFieldBlur('other_service_fee_field_value')}
                      error={
                        formik.touched.other_service_fee_field_value &&
                        Boolean(formik.errors.other_service_fee_field_value)
                      }
                      helperText={
                        formik.touched.other_service_fee_field_value && formik.errors.other_service_fee_field_value
                      }
                      InputProps={{
                        startAdornment: <span style={{ marginRight: '8px' }}>$</span>,
                        inputProps: { min: 0 },
                      }}
                      placeholder="Enter amount"
                      size="small"
                      style={{ width: '200px' }}
                    />
                  </Stack>
                </div>
              )}
            </FormControl>
          </Stack>
        </div>
      )}
    </>
  );
};

export default AdditionalServiceFeesSection;
